// Central definitions + persistence/side-effects for the GDPR cookie consent banner.

export const CONSENT_STORAGE_KEY = "cookieConsent";
export const CONSENT_VERSION = 1;
export const CONSENT_EVENT = "cookieConsentChanged";

export const CATEGORIES = [
  {
    key: "necessary",
    label: "Strictly Necessary",
    required: true,
    description:
      "Required for core site features such as login, cart, wishlist and comparisons. The site cannot function properly without these, so they cannot be switched off.",
  },
  {
    key: "analytics",
    label: "Analytics",
    required: false,
    description:
      "Google Analytics cookies that help us understand how visitors use the site so we can improve it. No analytics data is stored until you allow this category.",
  },
  {
    key: "marketing",
    label: "Marketing & Reviews",
    required: false,
    description:
      "Powers third-party embeds such as the Trustpilot reviews widget. These may set cookies used to personalize content and ads.",
  },
];

export const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  marketing: false,
};

export function getStoredConsent() {
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== CONSENT_VERSION) return null;
    const consent = {
      necessary: true,
      analytics: !!parsed.analytics,
      marketing: !!parsed.marketing,
    };
    applyConsentToScripts(consent);
    return consent;
  } catch {
    return null;
  }
}

export function saveConsent(consent) {
  const normalized = {
    necessary: true,
    analytics: !!consent.analytics,
    marketing: !!consent.marketing,
  };
  try {
    window.localStorage.setItem(
      CONSENT_STORAGE_KEY,
      JSON.stringify({
        ...normalized,
        version: CONSENT_VERSION,
        updatedAt: new Date().toISOString(),
      })
    );
  } catch {
    // localStorage unavailable (private mode, etc.) - consent still applies for this session.
  }
  applyConsentToScripts(normalized);
  return normalized;
}

export function applyConsentToScripts(consent) {
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: consent.analytics ? "granted" : "denied",
      ad_storage: consent.marketing ? "granted" : "denied",
      ad_user_data: consent.marketing ? "granted" : "denied",
      ad_personalization: consent.marketing ? "granted" : "denied",
    });
  }
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: consent }));
}
